<!-- 续费线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "billCode": "wdl201904251002",
                "monthTicketId": 4852,
                "parkCodes": "PR2WCYG4,2KKN6112",
                "originPrice": 10,
                "favorPrice": 5,
                "payMode": 4,
                "payModeRemark": "微信支付",
                "payOrigin": 7,
                "payOriginRemark": "1231",
                "renewBy": "张三",
                "renewTime": "2019-04-25 14:00:00",
                "timePeriodList": [
                    {
                        "startTime": "2019-03-29 00:00:00",
                        "endTime": "2019-03-30 23:59:59"
                    },
                    {
                        "startTime": "2019-04-29 00:00:00",
                        "endTime": "2019-04-30 23:59:59"
                    }
                ]
            },
            responseCode: {
                "data": {
                    "monthTicketBillId": 11
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 续费线上月票",
                t_url: this.commonUrls.test + "renewOnlineVipTicket",
                p_url: this.commonUrls.prod + "renewOnlineVipTicket",
                precondition: "无",
                fitSystem: "云停车场,VEMS传统车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方订单号，不得超过32个字符' },
                        { info1: 'parkCodes', info2: '否', info3: 'String', info4: '停车场编号列表，需与线上月票类型权限的parkCodes完全一致方可创建' },
                        { info1: 'monthTicketId', info2: '是', info3: 'Long', info4: '开通成功时返回的月票id' },
                        { info1: 'originPrice', info2: '是', info3: 'Decimal', info4: '票原总价，单位元' },
                        { info1: 'favorPrice', info2: '是', info3: 'Decimal', info4: '票折后总价，单位元' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'renewBy', info2: '是', info3: 'String', info4: '续费人' },
                        { info1: 'renewTime', info2: '是', info3: 'String', info4: '续费时间点，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'timePeriodList', info2: '是', info3: 'JSONArray', info4: '有效时间段列表' },
                    ]
                },{
                    titleName: 'timePeriodList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm:ss' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketBillId', info2: '是', info3: 'Long', info4: '月票账单流水号' },
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/renewOnlineVipTicket.vue